import { OpenInsuranceSelectorEvent } from "./insurance-selector-events.87d20ca02104.js";

/**
 * Handles interactions for the cost-share "add your benefits" banner.
 *
 * Binds handlers to `document` so they survive HTMX swaps.
 */
document.addEventListener("click", (e) => {
  const closeButton = e.target.closest(".cost-share-close");
  if (closeButton) {
    const banner = document.getElementById("cost-share-benefits-banner");
    if (banner) {
      banner.style.display = "none";
    }
    return;
  }

  const addBenefitsButton = e.target.closest("#add-benefits-button");
  if (addBenefitsButton) {
    document.dispatchEvent(
      new OpenInsuranceSelectorEvent(false, {
        navMethod: "benefits-banner",
      }),
    );
  }
});
